export function registerInitialTransports(faro) {
    faro.transports.add(...faro.config.transports);
    faro.transports.addBeforeSendHooks(faro.config.beforeSend);
    faro.transports.addIgnoreErrorsPatterns(faro.config.ignoreErrors);
}
//# sourceMappingURL=registerInitial.js.map